import { BlockStack, Card, Layout, SkeletonBodyText, SkeletonDisplayText, SkeletonPage } from '@shopify/polaris'
import i18next from 'i18next'

const BackorderSettingsFallback = () => {
  return (
    <SkeletonPage title={i18next.t('backordersDashTitle')} primaryAction backAction>
      <Layout>
        <Layout.AnnotatedSection title={i18next.t('backorderSelectionTypeTitle')} description={i18next.t('backorderSelectionTypeDescription')}>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={i18next.t('backorderProductsTitle')} description={i18next.t('backorderProductsIncludedDescription')}>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={i18next.t('backorderInventoryPolicyTitle')} description={i18next.t('backorderInventoryPolicyDescription')}>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.AnnotatedSection>
      </Layout>
    </SkeletonPage>
  )
}

export { BackorderSettingsFallback }
